if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.subscriptionSelector = document.querySelector('subscription-selector');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    async clearCartAndCheckout(config) {
      this.submitButton.classList.add('loading');

      return fetch(`/cart/clear`).then(() => {
        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.submitButton.setAttribute('aria-disabled', true);
              this.error = true;
              return;
            } else if (!this.cart) {
              // window.location = window.routes.cart_url;
              window.location = '/checkout';
              return;
            }

            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            this.submitButton.classList.remove('loading');
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
          });
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);

      const config = window.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id),
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      if (!this.subscriptionSelector) {
        config.body = formData;
        this.clearCartAndCheckout(config);
        return;
      } else {
        this.subscriptionSelector.openModal(formData);
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.querySelector('[data-product-form-error-message-wrapper]');

      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessageWrapper.querySelector('[data-product-form-error-message]');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
